import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const SurchargeRelationsSkeleton = () => (
  <>
    <SectionSkeleton height={200} />
    <SectionSkeleton height={300} />
  </>
);
